<div class="empty-tab">Select an element</div>

<style type="text/scss">
  @import "src/styles/variables.scss";

  .empty-tab {
    border: 1px dashed $dark-a;
    margin: 2.9rem 2.2rem;
    padding: 4rem;
    text-align: center;
    font-weight: 500;
  }
</style>
